export function MemoryLineChart(props: {
  ariaLabel: string;
  series: readonly { x: number; y: number; label?: string }[];
  referenceY?: number | null;
  yFormat?: (value: number) => string;
  xFormat?: (value: number) => string;
}) {
  if (props.series.length === 0) {
    return <p className="text-sm text-muted">No points to chart.</p>;
  }
  const ys = props.series.map((point) => point.y);
  const xs = props.series.map((point) => point.x);
  const minY = Math.min(0, ...ys, props.referenceY ?? 0);
  const maxY = Math.max(...ys, props.referenceY ?? 0);
  const spanY = maxY - minY || 1;
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const spanX = maxX - minX || 1;
  const left = 8;
  const top = 8;
  const width = 640;
  const height = 160;
  const plotW = width - 16;
  const plotH = height - 16;
  const coords = props.series.map((point) => {
    const x = left + ((point.x - minX) / spanX) * plotW;
    const y = top + plotH - ((point.y - minY) / spanY) * plotH;
    return `${x},${y}`;
  });
  const refY =
    props.referenceY === null || props.referenceY === undefined
      ? null
      : top + plotH - ((props.referenceY - minY) / spanY) * plotH;
  const last = props.series[props.series.length - 1];
  const yFormat = props.yFormat ?? ((value: number) => value.toFixed(3));

  return (
    <div>
      <svg role="img" aria-label={props.ariaLabel} viewBox={`0 0 ${width} ${height + 12}`} className="w-full">
        <title>{props.ariaLabel}</title>
        {refY !== null ? (
          <line x1={left} y1={refY} x2={left + plotW} y2={refY} stroke="currentColor" strokeOpacity="0.25" />
        ) : null}
        <polyline fill="none" stroke="#3f5d56" strokeWidth="1.5" points={coords.join(' ')} />
      </svg>
      <p className="text-xs text-muted">
        Last: {yFormat(last?.y ?? 0)}
        {props.referenceY !== null && props.referenceY !== undefined ? ` · baseline ${yFormat(props.referenceY)}` : ''}
      </p>
    </div>
  );
}
